import {
    ComparatorPicker,
    ComparatorPickerBuilder,
    ComparatorPickerType,
    ComparisonOperator,
    Field,
    FieldType,
} from "../../vforms-model";
import { CheckBoxComponent } from "./check-box.component";
import { CheckBoxEditorComponent } from "./check-box-editor.component";
import { ComparisonExpression } from "../../expression-settings/model";

export class CheckBoxType extends FieldType {
    static Id = "checkbox";

    constructor() {
        super();
        this.id = CheckBoxType.Id;
        this.icon = "mat_outline:check_box";
        this.previewComponent = CheckBoxComponent;
        this.editorComponent = CheckBoxEditorComponent;
    }

    createField(): Field {
        return new CheckBox(this);
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        switch (expression.operator) {
            case ComparisonOperator.Empty:
                return value === false;
            case ComparisonOperator.NotEmpty:
                return value === true;
        }

        return super.evaluate(expression, value);
    }
}

export class CheckBox extends Field {}

export class CheckboxComparatorPickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        return new ComparatorPicker(ComparatorPickerType.None);
    }
}
